import { BREAKPOINT_LARGE, HTML_WIDTH } from '../variables';

export function mobileProductList() {
  if (HTML_WIDTH >= BREAKPOINT_LARGE)
    return;

  $('.single-product-info').each(function() {
    $('.tinv-wraper', this).appendTo($('.product-categories', this));
  });
}
